import { render, staticRenderFns } from "./UpgraderItems.vue?vue&type=template&id=4ab89034&scoped=true"
import script from "./UpgraderItems.vue?vue&type=script&lang=js"
export * from "./UpgraderItems.vue?vue&type=script&lang=js"
import style0 from "./UpgraderItems.vue?vue&type=style&index=0&id=4ab89034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab89034",
  null
  
)

export default component.exports